
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Order } from '@/models/order';
import commonService from '@/services/common-services';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';

@Component
export default class DeliveryInfo extends Vue {
    @Prop({default: null})
    private customer: any;
    @Prop({default: null})
    private otherOption: any;

    get paymentRequestOrders() {
        return this.$store.state[APP_CONFIG.stateKey.cartState].paymentRequestOrders;
    }
}
